"use client";

import { useState } from "react";
import { api } from "~/utils/api";

export function useCheckListingAvailability(listingId: string) {
  const { refetch: refetchStillListed } = api.teeBox.checkIfTeeTimeStillListedByListingId.useQuery({
    listingId: listingId ?? "",
  });
  const getCache = api.cache.getCache.useMutation();
  const [availabilityError, setAvailabilityError] = useState<string | null>(null);

  // Returns true when it's safe to proceed to checkout, false when blocked
  // (availabilityError is set to the reason in that case).
  const checkListingAvailability = async (allowSplit: boolean | undefined, userId: string): Promise<boolean> => {
    setAvailabilityError(null);
    const stillListed = await refetchStillListed();
    if (!stillListed.data) {
      setAvailabilityError("The tee time is no longer available, please refresh your screen.");
      return false;
    }
    const value = (await getCache.mutateAsync({
      key: `listing_id_${listingId}`,
    })) as string | null;
    if (value && allowSplit) {
      const { userId: lockedByUserId } = JSON.parse(value) as { userId: string };
      if (lockedByUserId !== userId) {
        setAvailabilityError("The tee time is currently unavailable. Please check back in 20 mins.");
        return false;
      }
    }
    return true;
  };

  return { checkListingAvailability, availabilityError, setAvailabilityError };
}
